// components/NoDataScreen/NoDataScreen.tsx

import styles from "./noDataScreen.module.css";

export default function NoDataScreen() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.iconContainer}>
          <div className={styles.circle}></div>

          <svg
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <circle cx="12" cy="12" r="9" />

            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 10h.01M15 10h.01"
            />

            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9 16c1.5-1 4.5-1 6 0"
            />
          </svg>
        </div>

        <div className={styles.content}>
          <h1>Keine Daten gefunden</h1>

          <p>
            Für den ausgewählten Zeitraum sind derzeit keine Daten verfügbar.
            Bitte ändern Sie die Filter oder versuchen Sie es später erneut.
          </p>
        </div>

        <div className={styles.glow}></div>
      </div>
    </div>
  );
}